const EVENTS = {
  ACCOUNT_DEBUG_MENU_CLICKED: 'Account Debug Menu Clicked',
  ACCOUNT_SECURITY_CLICKED: 'Account Security Clicked',
  ACCOUNT_BUYING_CLICKED: 'Account Buying Clicked',
  ACCOUNT_SELLING_CLICKED: 'Account Selling Clicked',
  ACCOUNT_PROFILE_CLICKED: 'Account Profile Clicked',
  ACCOUNT_PORTFOLIO_CLICKED: 'Account Portfolio Clicked',
  ACCOUNT_FOLLOWING_CLICKED: 'Account Following Clicked',
  ACCOUNT_FAVORITES_CLICKED: 'Account Favorites Clicked',
  ACCOUNT_SETTINGS_CLICKED: 'Account Setting Clicked',
  ACCOUNT_LOGOUT_CLICKED: 'Account Log Out Clicked',
  AS_SEEN_ON_INSTAGRAM_CLICKED: 'As Seen On Instagram Clicked',
  AS_SEEN_ON_INSTAGRAM_IMPRESSION: 'As Seen On Instagram Impression',
  SOCIAL_MEDIA_LINK_CLICKED: 'Social Media Link Clicked',
  ADD_DISCOUNT: 'Add Discount',
  TOTAL_PAYOUT_CLICKED: 'Total Payout Clicked',
  DOPPLEGANGER_SELECTED: 'Doppleganger Selected',
  CLOSE_TOTAL_PAYOUT_CLICKED: 'Close Total Payout Clicked',
  STOCKX_PRO_LEARN_MORE_CLICKED: 'StockX Pro Learn More Clicked',
  CLIENT_SIDE_ERROR: 'Client Side Error',
  DISCOUNT_SUBMITTED: 'Discount Code Submitted',
  BANNER_CLICKED: 'Banner Clicked',
  BANNER_CAROUSEL_CLICKED: 'Banner Carousel Clicked',
  BANNER_CAROUSEL_ITEM_IMPRESSION: 'Banner Carousel Item Impression',
  BANNER_COLLAGE_CLICKED: 'Banner Collage Clicked',
  BANNER_COLLAGE_ITEM_IMPRESSION: 'Banner Collage Item Impression',
  BILLING: 'Billing',
  BRAND_TILE: 'Brand Tile Clicked',
  BUY_OR_BID: 'Buy or Bid Button Clicked',
  BUY_OR_BID_COMPLETED: 'Buy or Bid Completed',
  CANCEL_CLICKED: 'Cancel Clicked',
  CHAT_CLICK: 'Chat Click',
  CHECKOUT_FLOW_TOGGLE: 'Checkout Flow Toggle Clicked',
  CONFIRM_CLICKED: 'Confirm Clicked',
  DATE_RANGE_SELECTED: 'Date Range Selected',
  DELETE_ASK_CLICKED: 'Delete Ask clicked',
  DISCLAIMER_CLICKED: 'Disclaimer Clicked',
  EDIT_ASK_CLICKED: 'Edit Ask clicked',
  FILTER_CLICKED: 'Filter Clicked',
  FINISH_CLICKED: 'Finish Clicked',
  LEARN_MORE_CLICKED: 'Learn More Clicked',
  LIST_SORTED: 'List Sorted',
  LOGIN: 'Login',
  MAKE_AN_OFFER_CLICK: 'Make An Offer Click',
  MAKE_AN_OFFER_IMPRESSION: 'Make An Offer',
  MULTI_ASK_CLICKED: 'Multi-ask clicked',
  MULTI_EDIT_CLICKED: 'Multi-edit clicked',
  NAVIGATION_ITEM_CLICKED: 'Navigation Item Clicked',
  NEWS_ARTICLE_CLICKED: 'News Article Clicked',
  NEXT_CLICKED: 'Next Clicked',
  NOTIFICATION_PREFERENCE_EDITED: 'Notification Preference Updated',
  PAGINATION_CLICKED: 'Pagination Clicked',
  PRODUCT_CAROUSEL_VIEWED: 'Product Carousel Viewed',
  POPOUT_CLICKED: 'Pop out clicked',
  PRODUCT_ADDED_TO_PORTFOLIO: 'Product Added to Portfolio',
  PRODUCT_FOLLOWED: 'Product Followed',
  PRODUCT_UNFOLLOWED: 'Product Unfollowed',
  PRODUCT_IMAGE_CLICKED: 'Product Image Clicked',
  PRODUCT_LIST_VIEWED: 'Product List Viewed',
  PRODUCT_SHARED: 'Product Shared',
  PRODUCT_VIEWED: 'Product Viewed',
  PRODUCT_TILE: 'Product Tile Clicked',
  REVIEW_CLICKED: 'Review Clicked',
  SEARCH_SUGGESTED_VERTICAL_CLICKED: 'Search Suggested Vertical Clicked',
  SEARCH_RESULT_CLICKED: 'Search Result Clicked',
  SEE_ALL: 'See All Products Clicked',
  SELL_OR_ASK: 'Sell or Ask Button Clicked',
  SELL_OR_ASK_COMPLETED: 'Sell or Ask Completed',
  SELLING_TAB_CLICKED: 'Selling tab clicked',
  SHIPPING_ADDRESS_SUCCESS: 'Shipping Address Success',
  SHOW_MORE_OR_LESS_CLICKED: 'Show More or Less Clicked',
  SIGN_UP: 'Sign Up',
  SIZE_TILE: 'Size Tile Clicked',
  SELLING_SEARCH: 'Selling search executed',
  SELLING_SORT_CLICKED: 'Sort clicked',
  SETTINGS_UPDATED: 'Settings Updated',
  THREE_SIXTY_PRODUCT_IMAGE_ROTATED: '360 Product Image Rotated',
  TILE_COLLECTION_CLICKED: 'Tile Collection Clicked',
  USER_ACCOUNT_EDITED: 'User Account Edited',
  VERTICAL_PICKER: 'Vertical Picker Clicked',
  VIEW_ALL: 'View All Data Clicked',
  VIEW_TYPE_CHANGED: 'View Type Changed',
  ZERO_SEARCH_RESULTS: 'Zero Search Results',
  REGISTERED_NFT_NEWS: 'Registered For NFT News',
  EXPIRATION_CHANGED: 'Expiration Changed',
  ORDER_HISTORY_CLICKED: 'Order History Clicked',
  EDIT_CLICKED: 'Edit Clicked',
  INBOX_ICON_CLICKED: 'Inbox Icon Clicked',
  INBOX_MESSAGE_CLICKED: 'Inbox Message Clicked',
  INBOX_TOOLTIP_IMPRESSION: 'Inbox Tooltip Impression',
  INBOX_TOOLTIP_DISMISSED: 'Inbox Tooltip Dismissed',
  CROSS_BUYING_IMPRESSION_AND_CLICK: 'Shipping Options Selected',
  CROSS_BUYING_TOOLTIP: 'Vault Tooltip Clicked',
  REDEEM_CLICKED: 'Redeem Clicked',
  REDEEM_COMPLETED: 'Redeem Completed',
  ACCOUNT_CLICKED: 'Account Clicked',
  REDEEM_EDIT_CLICKED: 'Edit Icon Clicked',
  HTML_SITEMAP_POPULAR_PRODUCTS_VIEWED: 'HTML Sitemap Popular Products Viewed',
  HTML_SITEMAP_POPULAR_SEARCH_VIEWED: 'HTML Sitemap Popular Search Viewed',
  HTML_SITEMAP_POPULAR_BRANDS_VIEWED: 'HTML Sitemap Popular Brands Viewed',
  HTML_SITEMAP_LINK_CLICKED: 'HTML Sitemap Link Clicked',
  HELP_ICON_CLICKED: 'Help Icon Clicked',
  SAVE_CLICKED: 'Save Clicked',
  SHIPPING_ADDRESS_CHANGED: 'Shipping Address Changed',
  SUGGESTED_ADDRESS_ACTION: 'Suggested Address Clicked',
  INITIAL_PAGE_PERFORMANCE: 'Initial Page Performance',
  SHOP_BY_CATEGORY_TILE_CLICKED: 'Shop By Category Tile Clicked',
  CHK_OPTIMIZED_NEXT_CTA_WITHOUT_CANCEL_CLICKED: 'Next CTA without cancel',
  CHK_OPTIMIZED_NEXT_CTA_WITH_CANCEL_CLICKED: 'Next CTA with cancel',
  CHK_OPTIMIZED_PLACE_BID_CTA_WITH_CANCEL_CLICKED: 'Place Bid CTA with cancel',
  CHK_OPTIMIZED_PLACE_BID_CTA_WITHOUT_CANCEL_CLICKED:
    'Place Bid CTA without cancel',
  CHK_OPTIMIZED_PLACE_ORDER_CTA_WITH_CANCEL_CLICKED:
    'Place Order CTA with cancel',
  CHK_OPTIMIZED_PLACE_ORDER_CTA_WITHOUT_CANCEL_CLICKED:
    'Place Order CTA without cancel',
  SELLER_SHIPPING_EXTENSION_CLICKED: 'Extend Button Clicked',
  SWIPE_IN_USER_GENERATED_CONTENT_MODAL:
    'Swipe in User Generated Content Modal',
  CLOSE_CLICKED: 'Close Clicked',
  THREEDS_CHALLENGE: '3DS Challenge',
  THREEDS_CHALLENGE_RESPONSE: '3DS Challenge Response',
  PAYMENT_AUTHORIZED: 'Payment Authorized',
  SEE_MORE_PAYMENT_METHOD_CLICKED: 'See More Payment Methods Clicked',
  SEE_MORE_PAYMENT_METHOD: 'See More Payment Methods',
  PAYMENT_FORM: 'Payment Form',
  PAYMENT: 'Payment',
  BNPL_RESPONSE: 'BNPL Response',
  PAYMENT_METHOD_SUCCESS: 'Payment Method Success',
  PAYMENT_METHOD_FAILED: 'Payment Method Failed',
  PAYMENT_METHOD_CLICKED: 'Payment Method Clicked',
  BILLING_SAME_AS_SHIPPING_TOGGLE: 'Billing Same As Shipping Toggle',
  BADGE_VIEWED: 'Badge Viewed',
  EXPAND_HARDGATE_ACTIVITY_MODAL_DISCLAIMER_LABEL_CLICK:
    'Expand Hardgate Activity Modal Disclaimer Label Click',
  COLLAPSE_HARDGATE_ACTIVITY_MODAL_DISCLAIMER_LABEL_CLICK:
    'Collapse Hardgate Activity Modal Disclaimer Label Click',
  ASTERISK_VIEWED: 'Asterisk Viewed',
  OFFER_MESSAGES_IMPRESSION: 'Offer Messages Impression',
  ROKT_AD_IMPRESSION: 'Ad Served',
  ROKT_AD_ENGAGMENT: 'Ad Clicked',
};

export default EVENTS;
